import script from "./UserGrowthStats.vue?vue&type=script&setup=true&lang=js"
export * from "./UserGrowthStats.vue?vue&type=script&setup=true&lang=js"

import "./UserGrowthStats.vue?vue&type=style&index=0&id=5e97d512&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e97d512"]])

export default __exports__